import { getSharedColGroupStyles } from './shared';

export default () => ({
  '& col': {
    ...getSharedColGroupStyles(),

    '&.col-Budget': {
      width: 180,
      minWidth: 120,
      maxWidth: 800,
    },

    '&.col-Status, &.col-CampaignStatus, &.col-UiDisplayStatus, &.col-PerformanceTargetStatus': {
      width: 60,
      minWidth: 60,
      maxWidth: 800,
    },

    '&.col-CampaignId, &.col-AdGroupId': {
      width: 180,
      minWidth: 120,
      maxWidth: 800,
    },

    '&.col-AdID': {
      width: 240,
      minWidth: 120,
      maxWidth: 800,
    },

    '&.col-Bid': {
      minWidth: 100,
      maxWidth: 800,
    },

    '&.col-StartDate, &.col-EndDate': {
      width: 120,
      minWidth: 100,
      maxWidth: 800,
    },

    '&.col-SearchBid, &.col-Medium, &.col-AccountInactiveReasons, &.col-AccountNumber, &.col-CTR, &.col-Clicks, &.col-Conversions, &.col-Currency, &.col-Spend, &.col-CPA, &.col-ImpShareLostToBudget, &.col-ImpShareLostToRank, &.col-ImpShareLostToAdRelevance, &.col-ImpShareLostToExpectedCTR, &.col-ImpShareLostToBid, &.col-PhoneCost, &.col-ClickCalls, &.col-PhoneImpressions, &.col-PhoneThroughRate, &.col-AverageCPP, &.col-OverallEndDate, &.col-TotalEffectiveCost, &.col-TotalRemainingIOBudget, &.performance-metrics, &.phone-performance-metrics': {
      width: 120,
      minWidth: 80,
      maxWidth: 800,
    },

    // for German text
    '&.col-Impressions': {
      width: 130,
      minWidth: 80,
      maxWidth: 800,
    },

    // for German text
    '&.col-RevenueOnAdSpend, &.col-AllConversionRate': {
      width: 140,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-ConversionRate, &.performance-metrics.col-AdvertiserReportedRevenue, &.performance-metrics.col-ConversionRate, &.performance-metrics.col-PhoneCost, &.phone-performance-metrics.col-PhoneCost, &.phone-performance-metrics.col-ClickAndPhoneSpend': {
      width: 120,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-AdvertiserReportedRevenue, &.col-ImpShare, &.col-ManualCalls, &.col-AverageCPM, &.col-AverageCPC, &.col-AveragePosition, &.col-CampaignType, &.performance-metrics.col-ConversionRate, &.phone-performance-metrics.col-ConversionRate': {
      width: 120,
      minWidth: 80,
      maxWidth: 800,
    },

    // Portuguese text is lont in table header
    '&.performance-metrics.col-ExactMatchImpressionSharePercent, &.performance-metrics.col-ClickSharePercent, &.performance-metrics.col-TopImpressionSharePercent': {
      width: 140,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.performance-metrics.col-RevenueOnAdSpend, &.phone-performance-metrics.col-RevenueOnAdSpend': {
      width: 140,
      minWidth: 80,
      maxWidth: 800,
    },

    // German text is long in table header
    '&.performance-metrics.col-PhoneImpressions, &.phone-performance-metrics.col-PhoneImpressions': {
      width: 170,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-Labels, &.col-Locations, &.col-DeliveryStatus, &.col-Delivery, &.col-ContentBid, &.col-CallForwarding, &.col-QualityScore, &.col-DailyBudget, &.col-MonthlyBudget, &.col-IOBudget, &.col-BillToCustomerName, &.col-CompanyName, &.col-IOPurchaseOrder, &.col-RemainingIOBudget, &.col-FinalUrlSuffix, &.col-AdSchedule, &.col-Demographic, &.col-BidAdj, &.col-CampaignName, &.col-AdGroupName, &.col-Locations, &.col-DayTime, ': {
      width: 180,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-AccountName, &.col-DevicePreference, &.col-FirstPageBidEstimation': {
      width: 180,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-BestPositionBidEstimation': {
      width: 180,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-DisplayBiddingStrategyType, &.col-BidStrategyType, &.col-Language, &.col-Languages, &.col-AdType, &.col-KeywordId': {
      width: 240,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-AudienceName, &.col-Keyword, &.col-Name, &.col-AdGroup, &.col-Campaign, &.col-SearchTerm, &.col-LandingPage, &.col-CustomParameters': {
      width: 300,
      minWidth: 100,
      maxWidth: 800,
    },

    '&.col-AdPreview': {
      width: 360,
      minWidth: 260,
      maxWidth: 800,
    },

    '&.col-Changes': {
      width: 380,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-TrackingTemplate': {
      width: 420,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-DateTimeUser': {
      width: 220,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-Tool': {
      width: 150,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-Undo': {
      width: 150,
      minWidth: 80,
      maxWidth: 800,
    },

    '&.col-Location': {
      width: 240,
      minWidth: 140,
      maxWidth: 800,
    },

    '&.col-Industry, &.col-JobFunction': {
      width: 300,
      minWidth: 120,
      maxWidth: 800,
    },

    '&.col-Company': {
      width: 300,
      minWidth: 200,
      maxWidth: 800,
    },

    '&.col-DeviceName': {
      minWidth: 120,
      maxWidth: 800,
    },
  },
});
